import React from 'react';
import { Header, List, Table } from 'semantic-ui-react';

import {
    escribirMonto,
    imprimirArea,
    imprimirMetodoDePago,
    imprimirMotivo,
} from '../../utilidades';
import { PagosAsociadosAlAreaDelDia } from '../tipos';

interface TablaPagosDelDiaPorAreaProps {
    pagosDelDia: ReadonlyArray<PagosAsociadosAlAreaDelDia>;
}

const TablaPagosDelDiaPorArea: React.FunctionComponent<TablaPagosDelDiaPorAreaProps> = props => {
    const { pagosDelDia } = props;
    return (
        <div>
            <Header as='h4'>Pagos del dia</Header>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width={1}>Área</Table.HeaderCell>
                        <Table.HeaderCell width={1}>Motivo</Table.HeaderCell>
                        <Table.HeaderCell width={2}>Forma de pago</Table.HeaderCell>
                        <Table.HeaderCell width={2}>Monto Preu</Table.HeaderCell>
                        <Table.HeaderCell width={2}>Monto Ingles</Table.HeaderCell>
                        <Table.HeaderCell width={2}>Monto</Table.HeaderCell>
                        <Table.HeaderCell width={2}>Intereses</Table.HeaderCell>
                        <Table.HeaderCell width={2}>Total</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {pagosDelDia.map((x, indice) => (
                        <FilaPagosPorArea key={indice} pagosDelDia={x} />
                    ))}
                </Table.Body>
            </Table>
        </div>
    );
};

interface FilaPagosPorAreaProps {
    pagosDelDia: PagosAsociadosAlAreaDelDia;
}

const FilaPagosPorArea: React.FunctionComponent<FilaPagosPorAreaProps> = props => {
    const { pagosDelDia } = props;
    let pagoTarjeta = '';
    if (pagosDelDia.metodoDePago._tipo === 'tarjeta') {
        pagosDelDia.metodoDePago._tipoDeTarjeta === 'debito'
            ? (pagoTarjeta = 'Débito')
            : (pagoTarjeta = 'Crédito');
    }
    const montoPreu = pagosDelDia.infoArea.filter(x => x.area === 'preu');
    const montoIngles = pagosDelDia.infoArea.filter(x => x.area === 'ingles');
    return (
        <Table.Row>
            <Table.Cell>
                <List items={pagosDelDia.infoArea.map(x => imprimirArea(x.area))} />
            </Table.Cell>
            <Table.Cell>
                {imprimirMotivo(
                    pagosDelDia.tipoDePago === 'cobroCalculado'
                        ? pagosDelDia.tipoDePagoDeCobroCalculado!
                        : pagosDelDia.tipoDePago,
                )}
            </Table.Cell>
            <Table.Cell>
                {pagosDelDia.metodoDePago._tipo === 'tarjeta'
                    ? pagoTarjeta
                    : imprimirMetodoDePago(pagosDelDia.formaDePago)}
            </Table.Cell>
            <Table.Cell>{montoPreu.map(x => escribirMonto(x.monto))}</Table.Cell>
            <Table.Cell>{montoIngles.map(x => escribirMonto(x.monto))}</Table.Cell>
            <Table.Cell>{escribirMonto(pagosDelDia.monto)}</Table.Cell>
            <Table.Cell>{escribirMonto(pagosDelDia.intereses)}</Table.Cell>
            <Table.Cell>{escribirMonto(pagosDelDia.montoTotal)}</Table.Cell>
        </Table.Row>
    );
};

export default TablaPagosDelDiaPorArea;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Informes/Componentes/TablaPagosDelDiaPorArea.tsx